import * as React from "react";
import {
    Button,
    MenuItem, Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField
} from "@mui/material";
import {useEffect, useState} from "react";
import FunctionsData from "../../../Functions/FunctionsData";
import RedeemVoucher from "../RedeemVoucher/RedeemVoucher";
import {MdEmail, MdPhone} from "react-icons/md";
import moment from "moment";
import {CSVLink} from "react-csv";
import VouchersTableShowTableRow from "./VouchersTableShowTableRow";
import VouchersTableShowFilters from "./VouchersTableShowFilters";

export default function VouchersTableUnused(props) {

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [dataTbl, setDataTbl] = useState([]);
    const [currentRow, setCurrentRow] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [businessName, setbusinessName] = useState('');
    const [showModal, setShowModal] = useState(false);

    const [from, setFrom] = useState(false);
    const [to, setTo] = useState(false);
    const [campaigns, setCampaigns] = useState([]);
    const [searchCampaign, setSearchCampaign] = useState('all');
    const [csv, setCsv] = useState([]);

    useEffect(() => {
        FunctionsData.fetchDataGet(
            FunctionsData.getApiUrl('/api/orders/unusedvet/') + props.vet_id,
            setData,
            true,
            setLoading
        )
    }, [loading, props.vet_id])

    useEffect(() => {
        setDataTbl(data);
    }, [data])

    useEffect(() => {

        let arr = [];
        let c = [];

        for (let row in data) {

            c.push(data[row]['campaign_name']);

            let v = 0;
            for (let col in data[row]) {
                if (
                    String(data[row][col]).toLowerCase().trim().indexOf(String(searchTerm).toLowerCase().trim()) !== -1 ||
                    new Date(data[row][col]).toLocaleDateString('en-NZ').indexOf(String(searchTerm)) !== -1
                ) {
                    v = 1;
                }
            }
            if (v > 0 && (searchCampaign === '' || searchCampaign === 'all' || data['campaign_name'] === searchCampaign)) {
                arr.push(data[row]);
            }
        }

        if (from !== false) {
            //console.log(newData,new Date(from))
            arr = arr.filter(({created_at}) => moment(new Date(created_at)).format('YYYY-MM-DD') >= (from));
        }
        if (to !== false) {
            arr = arr.filter(({created_at}) => moment(new Date(created_at)).format('YYYY-MM-DD') <= (to));
        }


        setCampaigns([...new Set([...c])]);
        if (searchTerm === '' && to === false && from === false && searchCampaign === 'all') {
            setDataTbl(data);
            setCsvArray(data);
        } else {
            setCsvArray(arr);
            setDataTbl(arr);
        }

    }, [data, searchTerm, to, from, searchCampaign]);

    function setCsvArray(arrFiltered) {

        let arr = [];

        arrFiltered.forEach((row) => {
            arr.push({
                'Voucher #': row.sn,
                'Voucher issued': new Date(row.created_at).toLocaleDateString('en-NZ'),
                'Applicant Fee': (
                    (
                        row.sponsor_id > 0 &&
                        row.sponsor_applicant_cost > 0 &&
                        row.sponsor_microchip_extra_cost > -999
                    )
                    || ['community', 'inspectors'].includes(row.campaign_target)
                ) ? "No client fee" : "Client pays fee",
                'Name': row.first + ' ' + row.last,
                'Email': row.email,
                'Phone': row.phone,
                'Microchip Only':row.a_microchip_only_flag,
                'Animal name': row.a_name,
                'Age': row.a_age,
                'Gender': row.a_gender,
                'Primary color': row.a_color_primary,
                'Secondary color': row.a_color_secondary,
                'Source': row.a_source,
                'Microchipped': (row.a_microchipped) ? 'Yes' : 'No',
                'Pregnant': (row.is_pregnant > 0) ? 'Yes' : 'No',
                'Was recently pregnant': (row.was_pregnant > 0) ? 'Yes' : 'No'
            });
        })

        setCsv(arr);

    }

    const ShowTable = ({setLoading}) => {
        return (
            <Table sx={{minWidth: 650}} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell align="left">Voucher#</TableCell>
                        <TableCell align="left">Applicant fee</TableCell>
                        <TableCell align="left">Owner details</TableCell>
                        <TableCell align="left">Voucher issued</TableCell>
                        <TableCell align="left">Animal details</TableCell>
                        <TableCell align="right">&nbsp;</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {dataTbl?.map((row, idx) => {
                        return (
                            <VouchersTableShowTableRow key={row.id} row={row} showModal={showModal} onClick={() => {
                                setCurrentRow(row);
                                setShowModal(true);
                            }} setLoadingVouchers={setLoading}/>
                        )
                    })}
                </TableBody>
            </Table>
        )
    }

    if (loading === true) return (
        <div style={{padding: 20}}>
            <h3>Loading ...</h3>
        </div>
    )
    return (
        <div style={{minHeight: 200}}>
            <VouchersTableShowFilters campaigns={campaigns} searchCampaign={searchCampaign}
                                      setSearchCampaign={setSearchCampaign}
                                      searchTerm={searchTerm} setSearchTerm={setSearchTerm}
                                      from={from} setFrom={setFrom}
                                      to={to} setTo={setTo}
                                      showModal={showModal}businessName
                                       = {props.businessName} setbusinessName = {props.businessName}
            />
            {
                (dataTbl.length !== 0) ?
                    <>
                        <div style={{margin: '20px 0'}}>
                            {csv.length > 0 ?
                                <CSVLink data={csv} filename={"my_vouchers.csv"} target={"_blank"}>
                                    <Button variant={"contained"}>Download as CSV file to open in Excel</Button>
                                </CSVLink>
                                : undefined}
                        </div>
                        <ShowTable setLoading={setLoading}/>
                        <RedeemVoucher
                            key={1}
                            showModal={showModal}
                            setShowModal={setShowModal}
                            currentRow={currentRow}
                            setReloadOriginal={setLoading}
                        />
                    </>
                    : "No data found"
            }
        </div>
    )
}
